import React, { Component, ReactNode } from 'react';

import AppErrorModal from '~/components/AppErrorModal';

import { logError } from '../../utils/logError';

interface Props {
  /** Error boundary name */
  name?: string;
  children: ReactNode;
}

interface State {
  hasError: boolean;
  message: string;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      message: '',
    };
  }

  componentDidCatch(error: Error, errorInfo: unknown) {
    const { name } = this.props;
    logError(
      error,
      typeof errorInfo === 'object'
        ? {
            message: `Error in ErrorBoundary ${name ?? ''}`,
            ...errorInfo,
          }
        : errorInfo
    );
  }

  public static getDerivedStateFromError(error: Error): State {
    /* Update state so the next render will show the fallback UI */
    return {
      hasError: true,
      message: error.message,
    };
  }

  public render() {
    const { hasError, message } = this.state;
    const { children } = this.props;

    return hasError ? <AppErrorModal errors={[{ message }]} /> : children;
  }
}

export default ErrorBoundary;
